import { render, staticRenderFns } from "./SectionNumber.vue?vue&type=template&id=7a0d7e63&scoped=true&"
import script from "./SectionNumber.vue?vue&type=script&lang=ts&"
export * from "./SectionNumber.vue?vue&type=script&lang=ts&"
import style0 from "./SectionNumber.vue?vue&type=style&index=0&id=7a0d7e63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d7e63",
  null
  
)

export default component.exports